/**
 * CTA banner — looping background text (TZ section 6). Pure CSS animation (translateX 0 → -50% of two identical
 * halves); JS only sets the duration so the speed is constant whatever the text/screen width.
 * Figma motion (440:8797): 1500px in 9s ≈ 166px/s. Runs on all breakpoints (not a scroll effect).
 * Shared by every looping background text: markup `[data-marquee-track] > [data-marquee-group] ×2`
 * (cta-banner, ab-hiring).
 */
const SPEED = 60; // px per second — lower = slower (Figma prototype: 1500px/9s ≈ 166, too fast per the user)
const SPEED_MOB = 30; // < 1025px: the same px/s looks much faster on a narrow screen (user)

const speed = () => (window.matchMedia('(min-width: 1025px)').matches ? SPEED : SPEED_MOB);

export const ctaBanner = () => {
    return new Promise((resolve) => {
        const tracks = document.querySelectorAll('[data-marquee-track]');
        if (!tracks.length) {
            resolve();
            return;
        }

        const setDuration = () => {
            tracks.forEach((track) => {
                const group = track.querySelector('[data-marquee-group]');
                if (group && group.offsetWidth) {
                    track.style.animationDuration = `${group.offsetWidth / speed()}s`;
                }
            });
        };

        setDuration();
        document.fonts?.ready.then(setDuration);
        window.addEventListener('resize', setDuration);

        resolve();
    });
};
